import { Masterclass } from "api/resources/masterclasses/types"

export const MOCK_UPCOMING_MASTERCLASS: Masterclass = {
  id: 100000,
  title: "How to Engage Students in Online Classes",
  description:
    "Learn practical strategies to keep students engaged in online and hybrid classrooms.",
  topic: "Classroom Management",
  duration: "60 mins",

  startTime: new Date(Date.now() + 1000 * 60 * 60 * 24 * 7).toISOString(),

  timezone: "Asia/Kolkata",
  thumbnail: "",

  isRegistered: false,
  hasAttended: false,
  hasRecording: false,
  hasCertificate: false,

  joiningUrl: null,
  recordingUrl: null,
  recordingDuration: null,

  meetingType: "zoom" as any,
  slug: "onboarding-masterclass",
  userRestriction: {
    consumptionAllowed: true,
    validity: new Date(Date.now() + 1000 * 60 * 60 * 24 * 7).toISOString(),
  },
  videoMeetingId: -999,
}
